export default __webpack_public_path__ + "static/media/carvago-rounded-icon.cbb988d2.svg";